module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAMAAAApB0NrAAAANlBMVEUAAAD////////////////////////////////////////////////////////////////////xY8b8AAAAEnRSTlMA/0DAvz8Q8CDQYLCAkKBQMHA2zjUnAAAAdklEQVR4nNWTSwrAIAxEM9r6t5/7X7YBuwgpVLd5i4AyhDDMkF3SXHIgOqK2aU6hAVDJ8dQITQQaJZ6KLDRXbYGPchr+NE0obOGEDBQK28efLjT89DOfxx7/u2flHou8+dk1Mj+cwD7L4UqeRy9ur5G9WOmXLR4j9gNb2OCMdgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu4.png
// module id = LY/e
// module chunks = 1